import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { meetingQueryOptions } from '@/lib/query/meetingQuery';

export function useMeeting(meetingId?: string) {
  const { id } = useParams({ strict: false });
  const resolvedId = meetingId ?? id;
  return useQuery({
    ...meetingQueryOptions(resolvedId ?? ''),
    enabled: !!resolvedId,
  });
}
